export default __webpack_public_path__ + "static/media/color-palette.a789e551.png";